import { btnDelay, usePlaySound } from "common/utils";

type SokobanControllerProps = {
  onForward: () => void;
  onTurnLeft: () => void;
  onTurnRight: () => void;
  onJump: () => void;
  disabled?: boolean;
};

const buttonClass =
  "absolute w-[68px] h-[68px] rounded-full bg-white border-0 outline-none appearance-none p-0 flex items-center justify-center active:bg-gray2-100 active:scale-95 disabled:opacity-50 disabled:active:scale-100 transition-transform";

const iconClass = "material-symbols-outlined type-title text-textcolor-black";

export const SokobanController = ({
  onForward,
  onTurnLeft,
  onTurnRight,
  onJump,
  disabled,
}: SokobanControllerProps) => {
  const play = usePlaySound();

  const handle = (action: () => void) => () => {
    if (disabled) return;
    play();
    btnDelay(action);
  };

  return (
    <div className="fixed bottom-4 right-4 w-[200px] h-[200px] z-50 pointer-events-auto select-none touch-none">
      <button
        className={`${buttonClass} top-0 left-1/2 -translate-x-1/2`}
        onClick={handle(onForward)}
        disabled={disabled}
        aria-label="forward"
      >
        <span className={iconClass}>arrow_upward</span>
      </button>

      <button
        className={`${buttonClass} top-1/2 left-0 -translate-y-1/2`}
        onClick={handle(onTurnLeft)}
        disabled={disabled}
        aria-label="turn left"
      >
        <span className={iconClass}>arrow_back</span>
      </button>

      <button
        className={`${buttonClass} top-1/2 right-0 -translate-y-1/2`}
        onClick={handle(onTurnRight)}
        disabled={disabled}
        aria-label="turn right"
      >
        <span className={iconClass}>arrow_forward</span>
      </button>

      <button
        className={`${buttonClass} bottom-0 left-1/2 -translate-x-1/2`}
        onClick={handle(onJump)}
        disabled={disabled}
        aria-label="jump"
      >
        <span className={iconClass}>keyboard_double_arrow_up</span>
      </button>
    </div>
  );
};
